export default "__VITE_ASSET__JJbbQoTg__"